import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { ReportErrorMessage } from '../../domain/report-error-message';
import {AbstractControl, FormBuilder, FormGroup,FormsModule, NgControl, ValidatorFn,FormControl, Validators} from "@angular/forms";
//import * as Bowser from "bowser";
//import Bowser from "bowser"; // ES6 (and TypeScript with --esModuleInterop enabled)
import { ReportErrorService } from '../../service/report-error.service';
import { GlobalAppService } from '../../../core/commons/global-app.service';
import {MessageSeverity} from '../../../core/commons/message-severity';

//import { BowserService } from '/bowser-service';
import { Router } from '@angular/router';
import { BowserService } from "ngx-bowser";
import { FileUpload } from '../../../core/commons/file-upload-input/file-upload-input.component';

@Component({
  selector: 'app-report-errors',
  templateUrl: './report-errors.component.html',
  styleUrls: ['./report-errors.component.scss']
})

export class ReportErrorsComponent implements OnInit {

    form: FormGroup;
    files: FileList;
    image: String;
    @Output() onSent = new EventEmitter<boolean>();


    constructor(private fb: FormBuilder,
        private reportErrorService: ReportErrorService,
        private appService: GlobalAppService,
        private router: Router,
        private bowser: BowserService  ) {
        this.form = fb.group({
            subject:new FormControl ('', Validators.required),
            body:new FormControl ('', Validators.required),
        })
    }

  ngOnInit() {
  }


    getsubjectErrorMessage() {
        return this.form.get("subject").hasError("required")
                ? "Este campo es requerido."
                : "";
    }

    getBodyErrorMessage() {
        return this.form.get("body").hasError("required")
                ? "Este campo es requerido."
                : "";
    }

    seleccionImagen( archivo: File ){
        if(!archivo){
            this.image = null;
            return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(archivo);

        reader.onload = e => { // called once readAsDataURL is completed
            const photo = reader.result.toString();
        console.log(photo);
        this.image = photo;
        }
    }
   
    send() {
        this.appService.setLoading(true);
        let message = new ReportErrorMessage({
            
            subject: this.form.value.subject,
            solucionado: false,
            body: this.form.value.body + "\n \n \n \n "
             +"datos del navegador: "+ this.bowser.profile,
            image: this.image
        });
        
        this.reportErrorService.sendMessage(message)
            .subscribe(res => {
                this.appService.sendMsg(
                    MessageSeverity.SUCCESS,
                    'Guardado',
                    'Se ha enviado el reporte exitosamente'
                );
                this.appService.setLoading(false);
                this.goBack();
            },
            err => {
                this.appService.sendMsg(
                    MessageSeverity.ERROR,
                    'Error: ' + err.json().error,
                    'No se a podido enviar el reporte. ' + err.json().message
                );
                this.appService.setLoading(false);
            }
        );
            
        }

        goBack() {
            this.router.navigate(['']);
        }
        

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/report-errors/report-errors.component.ts